module.exports = __webpack_public_path__ + "static/img/huaiIdea.1f02f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/huaiIdea.png
// module id = SOPd
// module chunks = 0